export class WCObserver {
    constructor() {
        this.observers = [];
        this.addObserver = function (topic, observer) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            this.observers[topic] || (this.observers[topic] = []);
            this.observers[topic].push(observer);
        };
        this.removeObserver = function (topic, observer) {
            if (!this.observers[topic])
                return;
            const index = this.observers[topic].indexOf(observer);
            if (index !== -1) {
                this.observers[topic].splice(index, 1);
            }
        };
        this.notifyObservers = function (topic, message) {
            if (!this.observers[topic])
                return;
            for (let i = this.observers[topic].length - 1; i >= 0; i--) {
                this.observers[topic][i](message);
            }
        };
    }
}
